<template lang="html">
<div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary" >
   <!-- CONTENT
    ================================================== -->
    <div class="container" v-if="!isLoadingPage">
      <div class="row justify-content-center">
        <div class="col-12 col-md-5 col-xl-4 my-5">

          <!-- Heading -->
          <h1 class="display-4 text-center mb-3">
            Bem-Vindo!
          </h1>

          <!-- Form -->
          <form>

            <!-- Email address -->
            <div class="form-group">

              <!-- Label -->
              <label>Username</label>

              <!-- Input -->
              <input type="text" class="form-control" placeholder="Escolhe o nick" v-model="username">

            </div>
            <div class="form-group">

              <!-- Label -->
              <label>E-mail</label>

              <!-- Input -->
              <input type="email" class="form-control" placeholder="Digite o email" v-model="email">

            </div>
            <!-- Password -->
            <div class="form-group">

              <div class="row">
                <div class="col">

                  <!-- Label -->
                  <label>Senha</label>

                </div>
                <div class="col-auto">
                </div>
              </div> <!-- / .row -->

              <!-- Input group -->
              <div class="input-group input-group-merge">
                <!-- Input -->
                <input type="password" class="form-control form-control-appended" placeholder="Digite sua senha" v-model="password" @input="checkPass">
              </div>
                <span class="text-muted msg" v-if="errorPass">{{errorPassMsg}}</span>
            </div>
            <div class="form-group">

              <div class="row">
                <div class="col">

                  <!-- Label -->
                  <label>Confirme sua senha</label>

                </div>
                <div class="col-auto">
                </div>
              </div> <!-- / .row -->

              <!-- Input group -->
              <div class="input-group input-group-merge">
                <!-- Input -->
                <input type="password" class="form-control form-control-appended" placeholder="Digite sua senha" v-model="password2" @input="checkPassConfirm">               
              </div>
               <span class="text-muted msg" v-if="errorPassConfirm">{{errorPassMsgConfirm}}</span>
            </div>
             <div class="input-group input-group-merge">
              <!-- <vue-recaptcha 
                sitekey="6LcLr8wZAAAAAFkCHD0sFwcBPA_YQBKtWjDBu5F2"
                ref="recaptcha"
                @verify="onVerify"
                @expired="onExpired">
              </vue-recaptcha> -->
              </div>
            <!-- Submit -->
            <div v-if="isLoading" class="title-center" style="margin-top:30px;">
                  <atom-spinner 
                  :size="50"
                  :color="'#FFFFFF'"
                  />
            </div>
            <button v-else class="btn btn-lg btn-block btn-primary mb-3" style="margin-left: -3px;margin-top:10px;" @click.prevent="submit" :disabled='disabled'>
              Registrar!!
            </button>
            <div  v-if="showErros" >
              <div v-for="(z,x) in erros" :key="x">
                <span >{{x | uppercase }}: {{z[0]}}</span>
                <br/>
              </div>
            </div>

          </form>

        </div>
      </div> <!-- / .row -->
    </div> <!-- / .container -->
    <div v-else class="container">
          <div class="row justify-content-center" style="margin-top:25%;">   
            <div class="spinner">
            <atom-spinner 
                :animation-duration="1000"
                :size="80"
                :color="'#1dbbff'"
              />
            </div>  
          </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import {AtomSpinner} from 'epic-spinners'
// import VueRecaptcha from 'vue-recaptcha'

export default {
  props: ['streamer'],
  components:{
    AtomSpinner,
    // VueRecaptcha
  },
  data () {
    return {
      username: '',
      password: '',
      password2: '',
      email: '',
      isLoading: false,
      isLoadingPage: true,
      captchaChecked: false,
      errorPass : false,
      errorPassConfirm: false,
      showErros: false,
      erros: {},
      disabled : true,
      captchaVeri: false
    }
  },
  mounted () {
    axios.get(`get_apoiador/${this.streamer}`)
    .then(resp =>{
      this.isLoadingPage = false
      console.log(resp)
    })
    .catch(err =>{
      this.$router.push({name: '404'})
      console.log(err)
    })
  },
  methods: {
    onVerify: function () {
      console.log('Verify')
      this.captchaVeri = true
      this.checkFields()
    },
    onExpired: function () {
      console.log('Expired')
      this.$refs.recaptcha.reset()
      this.captchaVeri = false
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    },
    submit () {
      axios.post('account/register', {
        email: this.email,
        username: this.username,
        password: this.password,
        apoiador: this.streamer
      })
      .then(resp => {
        console.log(resp.data)
        if (resp.data.error) {
          this.erros = resp.data.error
          this.$notify('Não conseguimos cria sua conta, verifique os erros e tente novamente!', 'error')
          this.showErros = true
        } else {
          this.$notify('Quase lá! Em breve você receberá um e-mail para confirmar a criação da sua conta!', 'success')
          this.isLoading = false
          setTimeout(() => {
            this.$router.push({name: 'Login'})
          }, 5000)          
        }
      })
      .catch(err => {
        this.erros = err.response.data
        console.log(this.erros)
        this.$notify('Não conseguimos cria sua conta, verifique os erros e tente novamente!', 'error')
        for (var element in err.response.data){
          this.$notify(`${element} - ${err.response.data[element]}`, 'error')
          console.log(element)
        }
        this.showErros = true
        this.isLoading = false
      })
      .catch(err => {
        console.log(err.data)
      })
    },
    checkPass () {
      if (this.password.length < 8) {
        this.errorPass = true
        this.errorPassMsg = 'A senha deve conter mais de 8 caracteres'
      } else {
        this.errorPass = false
      }
    },
    checkPassConfirm () {
      if (this.password == this.password2) {
        this.errorPassConfirm = false
      } else {
        this.errorPassConfirm = true
        this.errorPassMsgConfirm = 'As senhas devem ser iguais.'
      }
      this.checkFields()
    },
    checkFields () {
      if ( this.errorPass == false && this.errorPassConfirm == false && this.email.length >0 && this.username.length > 0 && this.captchaVeri == false) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
  }
}
</script>

<style>
.msg {
  color: red;
}
</style>
